module.exports = __webpack_public_path__ + "static/media/lelillz.cd7a84ba.svg";